import { Fragment } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    CircularProgress,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { Check } from '@mui/icons-material';
import AlertDialog from '../../../../../components/Dialog/AlertDialog';
import useCheckInStaffList from './hooks/useCheckInStaffList';
import DrawerOverlay from '../../../../../components/Drawer/DrawerOverlay';
import { capitalizeString } from '../../../../../utils/strings/capitilize';
import { Body2, H5, H6, Body1 } from '../../../../../themes/typography';

export default function CheckInStaffList({
    data = []
}) {

    const {
        handleMenuItemClick,
        handleConfirmRevoke,
        reGenerateInviteCode,
        loading,
        regeneratedStates,
        selectedInvitationId,
        openDialog,
        handleAlertDialogCancel,
        openDrawer,
        closeDrawer,
        handleSubmitDetails,
        selectedTicketIds,
        tickets,
        handleTicketsSelection,
        handleStaffPermission,
        handleSelectAllTickets
    } = useCheckInStaffList(data);

    return (
        <Fragment>
            <div className="check-in-staff-list-container">
                <TableContainer sx={tableContainerStyle}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead sx={dataCellStyle}>
                            <TableRow sx={dataCellStyle}>
                                {/* <TableCell align="center" sx={headerCellStyle}>
                                    <H6>No.</H6>
                                </TableCell> */}

                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Name</H6>
                                </TableCell>

                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Email</H6>
                                </TableCell>

                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Phone</H6>
                                </TableCell>

                                <TableCell align="center" sx={headerCellStyle}>
                                    <H6>Action</H6>
                                </TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.map((row, index) => (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}
                                    sx={{ borderBottom: '1px solid rgba(153, 166, 173, 0.35)' }}
                                >
                                    {/* <TableCell align="center" sx={dataCellStyle}>
                                        <Body2>
                                            {index + 1}
                                        </Body2>
                                    </TableCell> */}

                                    <TableCell align="center" sx={dataCellStyle}>
                                        <Body1 fontWeight={350}>
                                            {capitalizeString(row.name, true)}
                                        </Body1>
                                    </TableCell>

                                    <TableCell align="center" sx={dataCellStyle}>
                                        <Body1 fontWeight={350}>
                                            {row.email ? row.email : '-'}
                                        </Body1>
                                    </TableCell>

                                    <TableCell
                                        align="center"
                                        sx={{
                                            ...dataCellStyle,
                                            width: '132px',
                                        }}
                                    >
                                        <Body1 fontWeight={350}>
                                            {row.phone ? row.phone : '-'}
                                        </Body1>
                                    </TableCell>

                                    <TableCell
                                        align="flex-end"
                                        sx={{
                                            ...dataCellStyle,
                                            gap: '1rem',
                                            display: 'flex',
                                            justifyContent: 'space-evenly',
                                            alignItems: 'center',
                                            padding: '0.625rem'
                                        }}
                                    >

                                        <div
                                            style={{
                                                minWidth: 120,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Button
                                                variant={!row.access ? 'markAsSoldOut' : 'text'}
                                                disabled={!row.access}
                                                sx={{
                                                    color: 'var(--error-main-color)',
                                                    padding: '0.313rem 0.625rem',
                                                    maxHeight: '32px',
                                                    '&.Mui-disabled': {
                                                        opacity: '1',
                                                        backgroundColor: 'transparent'
                                                    }
                                                }}
                                                onClick={() => {
                                                    const optionIndex = row.access ? 1 : 0;
                                                    handleMenuItemClick(null, optionIndex, index);
                                                }}
                                                startIcon={!row.access ? <Check /> : null}
                                            >
                                                {!row.access ? 'Revoked' : 'Revoke'}
                                            </Button>
                                        </div>

                                        <div style={{ height: '44px', borderRight: '1px solid var(--divider-color)' }}></div>

                                        <div
                                            style={{
                                                minWidth: 148,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            {regeneratedStates[row.id] ? (
                                                <Button
                                                    variant="success"
                                                    sx={{ pointerEvents: 'none', cursor: 'none' }}
                                                    startIcon={<Check />}
                                                >
                                                    Regenerated
                                                </Button>
                                            ) : (
                                                <Button
                                                    disabled={!row.access || (loading && selectedInvitationId === row.id && !openDialog)}
                                                    onClick={() => reGenerateInviteCode(row.id)}
                                                    variant="warning"
                                                >
                                                    Regenerate {loading && selectedInvitationId === row.id && !openDialog && (
                                                        <CircularProgress
                                                            size={20}
                                                            sx={{ marginLeft: '0.75rem', color: 'var(--secondary-color)' }}
                                                        />
                                                    )}
                                                </Button>
                                            )}
                                        </div>

                                        <div style={{ height: '44px', borderRight: '1px solid var(--divider-color)' }}></div>

                                        <div
                                            style={{
                                                minWidth: 148,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <Button
                                                variant={row?.ticket_types?.length > 0 ? 'success' : 'text'}
                                                onClick={() => handleStaffPermission(row.id)}
                                                disabled={!row.access}
                                                sx={{
                                                    '&.Mui-disabled': {
                                                        backgroundColor: 'transparent',
                                                        color: 'var(--secondary-color)',
                                                    }
                                                }}
                                            >
                                                {row?.ticket_types?.length > 0 ? 'Permission set' : 'Set permission'}
                                            </Button>
                                        </div>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <AlertDialog
                open={openDialog}
                onCancel={handleAlertDialogCancel}
                onConfirm={handleConfirmRevoke}
                dialogTitle="Confirm Revoke Access"
                primaryBtnName="Continue"
                secondaryBtnName="Cancel"
                disabled={(loading)}
            >
                <Body2>
                    Are you sure you want to revoke this staff member's access? <br />
                    <strong>This action cannot be undone.</strong>
                </Body2>
            </AlertDialog>

            <DrawerOverlay
                // open={true}
                open={openDrawer}
                onClose={closeDrawer}
                onClick={handleSubmitDetails}
                disabled={selectedTicketIds.length === 0}
                drawerTitle='Give Permissions to Check-In Staff'
                primaryButtonText='Submit'
                secondaryButtonText='Close'
                loading={loading}
            // disabled={loading}
            >
                <div className='selection-of-ticket-types-container'>

                    <div className='selection-of-ticket-types-wrapper'>

                        <div className='selection-of-ticket-type-label'>
                            <H5 fontWeight={400}>
                                Select the tickets to give access to this staff member :
                            </H5>
                        </div>

                        <div className='selection-of-ticket-types-list'>

                            <div className='selection-of-ticket-type-list-item'>
                                <FormControlLabel
                                    control={<></>
                                        // <Checkbox
                                        //     color="secondary"
                                        //     checked={selectedTicketIds.length === tickets.length && tickets.length > 0}
                                        //     onChange={handleSelectAllTickets}
                                        // />
                                    }
                                    onClick={handleSelectAllTickets}
                                    label={<Body1>{selectedTicketIds.length === tickets.length && tickets.length > 0 ? 'All selected' : 'Select All'}</Body1>}
                                    sx={{ ...ticketsSelectionStyles, textDecoration: 'underline' }}
                                />
                            </div>

                            {tickets.length > 0 && tickets.map((ticket) => (
                                <div className='selection-of-ticket-type-list-item' key={ticket.ticket_id}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color="secondary"
                                                value={ticket.ticket_id}
                                                checked={selectedTicketIds.includes(ticket.ticket_id)}
                                                onChange={(event) => handleTicketsSelection(event, ticket.ticket_id)}
                                            />
                                        }
                                        label={<Body1>{ticket.ticket_name}</Body1>}
                                        sx={ticketsSelectionStyles}
                                    />
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </DrawerOverlay>
        </Fragment>
    );
}

const tableContainerStyle = {
    borderTopRightRadius: '1rem',
    borderTopLeftRadius: '1rem',
    maxHeight: '70vh'
};

const headerCellStyle = {
    backgroundColor: '#283853',
    borderBottom: 'none'
};

const dataCellStyle = {
    borderBottom: '1px solid rgba(153, 166, 173, 0.35)',
    // padding: '0rem'
};

const ticketsSelectionStyles = {
    alignItems: 'flex-start',
    gap: '0.5rem',
    '& .MuiFormControlLabel-label': {
        minHeight: '34px',
        display: 'flex',
        alignItems: 'center'
    }
}